<!-- @format -->

<template>
	<div>
		<pc-dialog
			v-model="feedback.visabled"
			:title="title"
			width="860px"
			@on-confirm="onEditConfirm"
			@on-cancel="onEditCancel"
			@close="onEditCancel"
		>
			<el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
				<el-tab-pane label="意见反馈" name="first">
					<el-form ref="FeedbackRef" :model="feedback.FeedbackContent" label-width="90px" :rules="feedback.rules">
						<el-form-item label="意见反馈" prop="FeedbackContent">
							<pc-editor
								:value="feedback.FeedbackContent.FeedbackContent"
								:min-height="200"
								style="width: 100%"
								@chang-content="changContent"
							/>
						</el-form-item>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="反馈记录" name="second">
					<pc-table
						v-model:page-value="pageValue"
						:data="tableList.list || []"
						:column-list="columnList"
						:total="tableList.total"
						show-total
						:setting-column-config="settingColumnConfig"
						:setting-column-props="{ width: 120 }"
						@setting-action="settingAction"
					>
						<template #column-default-disposeShow="scope">
							<el-tag :type="scope.row.dispose === 'N' ? 'danger' : ''">{{ scope.row.disposeShow }}</el-tag>
						</template>
					</pc-table>
				</el-tab-pane>
			</el-tabs>
		</pc-dialog>
		<!-- 查看详情 -->
		<pc-dialog v-model="feedbackdetail.visabled" title="意见详情" destroy-on-close :show-footer="false">
			<el-form ref="FeedbackRefNew" :model="feedbackdetail" label-width="90px">
				<el-form-item label="意见反馈" prop="FeedbackContent">
					<pc-editor
						:value="feedbackdetail.feedbackContent"
						read-only
						:min-height="200"
						style="width: 100%"
						class="pcEditor"
					/>
				</el-form-item>
				<el-form-item label="意见回复" prop="answerContent">
					<pc-editor
						v-if="feedbackdetail.answerContent"
						:value="feedbackdetail.answerContent"
						read-only
						:min-height="200"
						style="width: 100%"
						class="pcEditor"
					/>
					<span v-else>--</span>
				</el-form-item>
			</el-form>
		</pc-dialog>
	</div>
</template>
<script setup lang="ts">
	import { ref, watch } from 'vue';
	import type { FormInstance } from 'element-plus';
	import { PcDialog, PcTable, PcEditor } from '@/components';
	import { getFeedBackList, addFeedBack } from '@/api/user/index';

	interface Props {
		visible: boolean;
		title?: string;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emit = defineEmits(['close']);

	const activeName = ref('first');

	const FeedbackRef = ref<FormInstance>();

	const pageValue = ref({ pageNum: 1, pageSize: 20 });

	const feedback = ref({
		visabled: props.visible,
		FeedbackContent: {
			FeedbackContent: '',
		},
		rules: {
			FeedbackContent: [
				{
					required: true,
					message: '请填写意见反馈',
					trigger: 'blur',
				},
			],
		},
	});

	const feedbackdetail = ref({
		visabled: false,
		feedbackContent: '',
		answerContent: '',
	});

	const tableList = ref({
		list: [],
		total: 0,
	});
	const columnList = ref([
		{
			label: '反馈内容',
			code: 'feedbackContentFormat',
			type: 'input',
		},
		{
			label: '回复状态',
			code: 'disposeShow',
			type: 'input',
			colProps: {
				width: 100,
			},
		},
	]);

	const settingColumnConfig = [
		{
			label: '查看',
			value: 'detail',
		},
	];

	const settingAction = (type, scope, callback) => {
		switch (type) {
			case 'detail':
				onDetail(scope.row.feedbackContent, scope.row.answerContent);
				callback && callback();
				break;
			default:
				break;
		}
	};

	const onDetail = (feedbackContent, answerContent) => {
		feedbackdetail.value = {
			visabled: true,
			feedbackContent,
			answerContent,
		};
	};

	const changContent = (val) => {
		feedback.value.FeedbackContent.FeedbackContent = val;
	};

	const onEditConfirm = async (callback?: Function) => {
		callback && callback();
		if (activeName.value == 'first') {
			FeedbackRef.value?.validate(async (isVaild) => {
				if (isVaild) {
					const res: any = await addFeedBack({ feedbackContent: feedback.value.FeedbackContent.FeedbackContent });
					if (res.code == 200) {
						onEditCancel();
					}
				}
			});
		} else {
			onEditCancel();
		}
	};
	const onEditCancel = (callback?: Function) => {
		callback && callback();
		emit('close', false);
	};

	const handleClick = (tab) => {
		if (tab.paneName == 'second') {
			getData();
		}
	};

	const getData = async () => {
		const res: any = await getFeedBackList({});
		if (res.code == 200) {
			tableList.value = {
				list: res.data.rows || [],
				total: res.data.total || 0,
			};
		}
	};

	watch(
		() => props.visible,
		() => {
			feedback.value.visabled = props.visible;
			feedback.value.FeedbackContent.FeedbackContent = '';
		},
		{
			immediate: true,
		},
	);
</script>
<style scoped lang="scss">
	.pcEditor {
		border: 1px solid #ccc;

		:deep(.ql-toolbar.ql-snow) {
			display: none;
		}

		:deep(.ql-container.ql-snow) {
			border: none;
		}
	}
</style>
